import produce from "immer";
import {enableES5} from "immer";
import {createAction, handleActions} from 'redux-actions';

enableES5();

const initialState = {
    config: {},
    query: '',
    nowpage: 'gate',
    layerName: '',
    secCookies: {
        gate: false,
        banquetIntro: false,
        banquetKeynote: false,
        livingroom: false,
        passage: false,
        garden: false,
    },
    secCookiesIsFull: false,
    stamp: [],
    stampLength: 0,
    isInviteUser: false,
};

// actions--------------------------------------------------------------------------------
export const actions = {
    setConfig: createAction('linm3rdpromo/SET_CONFIG'),
    setQuery: createAction('linm3rdpromo/SET_QUERY'),
    setNowpage: createAction('linm3rdpromo/SET_NOWPAGE'),
    setSecCookies: createAction('linm3rdpromo/SET_SECCOOKIES'),
    setSecCookiesIsFull: createAction('linm3rdpromo/SET_SECCOOKIESISFULL'),
    addSecCookies: createAction('linm3rdpromo/SET_ADDSECCOOKIES'),
    setStamp: createAction('linm3rdpromo/SET_STAMP'),
    addStamp: createAction('linm3rdpromo/ADD_STAMP'),
    setInviteUser: createAction('linm3rdpromo/SET_INVITEUSER'),
    loadStamp: () => (dispatch, getState) => {
        $.ajax({
            url: `/event/200624_thirdupdate/missionCard`, 
            data: `[${getState().stamp.toString()}]`,
            type: 'POST', dataType: 'json', contentType: 'application/json',
        })
        .fail(() => {
            console.log( '::::::::::::::::: error :::::::::::::::::' );
        })
        .done((data) => {
            dispatch( actions.setStamp(data) );
        })
        .always(() => {});

        $.ajax({
            url: `/event/p2020/200610_invitation/find`, 
            type: 'GET', dataType: 'json', contentType: 'application/json', withCredentials: true
        })
        .fail(() => {
            console.log( '::::::::::::::::: error :::::::::::::::::' );
        })
        .done((data) => {
            dispatch( actions.setInviteUser(/code=invite/.test(data.extraData)) );
        })
        .always(() => {});
    },
};

// handlers--------------------------------------------------------------------------------
export default handleActions({
    [actions.setConfig] : (state, action) => produce(state, draft => {draft.config = action.payload;}),
    [actions.setQuery] : (state, action) => produce(state, draft => {draft.query = action.payload;}),
    [actions.setNowpage] : (state, action) => produce(state, draft => {draft.nowpage = action.payload;}),
    [actions.setInviteUser] : (state, action) => produce(state, draft => {draft.isInviteUser = action.payload;}),
    [actions.setSecCookies] : (state, action) => produce(state, draft => {
        draft.secCookies = action.payload;
        draft.secCookiesIsFull = checkSectionCookieFull(draft);
    }),
    [actions.addSecCookies] : (state, action) => produce(state, draft => {
        draft.secCookies[action.payload] = true;
        localStorage.setItem('linm3rd_sectionchecklist', JSON.stringify(draft.secCookies));
        draft.secCookiesIsFull = checkSectionCookieFull(draft);
    }),
    [actions.setStamp] : (state, action) => produce(state, draft => {
        draft.stamp = draft.stamp.concat( action.payload );
        checkStampLength(draft);
    }),
    [actions.addStamp] : (state, action) => produce(state, draft => {
        draft.stamp.push( action.payload );
        checkStampLength(draft);
    }),
}, initialState);


//----------------------------------------------------------------
function checkSectionCookieFull(draft) {
    let isfull = true;
    [ 'gate', 'banquetIntro', 'banquetKeynote', 'livingroom', 'passage', 'garden' ].map( it => {
        if (!draft.secCookies[it]) isfull = false;
    });
    return isfull;
}

function checkStampLength(draft) {
    draft.stamp = draft.stamp.filter((item, index) => draft.stamp.indexOf(item) === index);
    localStorage.setItem('linm3rd_stamplist', JSON.stringify(draft.stamp));

    let stampleng = [1,2,3,4,6].filter( it => (draft.stamp.indexOf(it)>=0) ).length;
    let is5full = true;
    [54,55,56,57,58,59,510,511,512,513].map( it => {
        if (draft.stamp.indexOf(it)<0) is5full = false;
    });
    stampleng = is5full? stampleng+1: stampleng;
    draft.stampLength = stampleng;
}